import React from "react";
import { IChoiceGroupOption, IChoiceGroupOptionProps } from "@fluentui/react";

// Custom render field component for ChoiceGroup
export const CustomChoiceField = ({
  props,
  render,
  className
}: {
  props?: IChoiceGroupOption & IChoiceGroupOptionProps;
  render?: (props?: IChoiceGroupOption & IChoiceGroupOptionProps) => React.ReactElement | null;
  className: string;
}) => {
  if (!render || !props) return null;
  return <div className={className}>{render(props)}</div>;
};

// Custom render field factory
export const createChoiceFieldRenderer = (className: string) => {
  const renderer = (props: any, render: any) => (
    <CustomChoiceField props={props} render={render} className={className} />
  );
  renderer.displayName = "ChoiceFieldRenderer";
  return renderer;
};